import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const recordMappingFeedback = api(async function recordMappingFeedback(payload) {
    return mutate(
        gql`
            mutation RecordMappingFeedback(
                $runId: String
                $feedbackAttemptId: String
                $registerId: String!
                $assetTypeId: String!
                $assetType: String!
                $selections: [JSONObject]
                $viewedScheduleIds: [String!]
                $excludedByUser: Boolean
                $decision: String
            ) {
                recordMappingFeedback(
                    runId: $runId
                    feedbackAttemptId: $feedbackAttemptId
                    registerId: $registerId
                    assetTypeId: $assetTypeId
                    assetType: $assetType
                    selections: $selections
                    viewedScheduleIds: $viewedScheduleIds
                    excludedByUser: $excludedByUser
                    decision: $decision
                )
            }
        `,
        payload,
        { returns: "recordMappingFeedback" }
    )
})
